module.exports = __webpack_public_path__ + "img/programme1.a474a782.png";